/*
 * Extenders do fórum para os marcadores: o modelo no store, a rota da aba do
 * perfil, o componente da notificação de lembrete e os atributos que o PHP
 * acrescenta aos posts. O agente principal espalha este array no `extend` do
 * fórum.
 */
import Extend from 'flarum/common/extenders';
import Post from 'flarum/common/models/Post';
import UserPageResolver from 'flarum/forum/resolvers/UserPageResolver';
import Bookmark from './Bookmark';
// Páginas carregadas sob demanda (chunk próprio): não pesam na primeira carga.
const BookmarksUserPage = () => import(/* webpackChunkName: 'forum/features/bookmarks/components/BookmarksUserPage', webpackMode: 'lazy-once' */ './components/BookmarksUserPage');
import BookmarkReminderNotification from './components/BookmarkReminderNotification';
export default [new Extend.Store() //
.add('canela-bookmarks', Bookmark),
// O servidor já atende `/u/{username}[/{filter}]` com a página do perfil:
// a URL abre direto, sem rota nova no PHP.
new Extend.Routes() //
.add('canela.user.bookmarks', '/u/:username/bookmarks', BookmarksUserPage, UserPageResolver), new Extend.Notification() //
.add('canelaBookmarkReminder', BookmarkReminderNotification), new Extend.Model(Post) //
.attribute('bookmarked').attribute('bookmarkId').attribute('bookmarkName').attribute('bookmarkReminderAt', value => value ? new Date(value) : null)];flarum.reg.addChunkModule('forum/features/bookmarks/components/BookmarksUserPage', './src/forum/features/bookmarks/components/BookmarksUserPage.tsx', 'ramon-canela', 'forum/features/bookmarks/components/BookmarksUserPage');